var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeaderUI',{attrs:{"title":"Shipment Timeline","breadcrumb":"Dashboard > Operations > Shipments"}}),_c('BookingsTimeLine')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }